import React from "react";
import DefaultLayout from "./DefaultLayout";
import classnames from "classnames";
import VerticalBarChart from "../charts/VerticalBarChart";
import Loading from "../components/Loading";
import { connect } from "react-redux";
import "./PrintStyle.css";

class VerticalBarChartLayout extends DefaultLayout {
  render() {
    const { metric, visible, index, showTitle = true, dataKey } = this.props;
    const { isLoading, data } = this.state;
    return (
      <div
        className={classnames("col-12", "p-0", { "d-none": visible === false })}
      >
        {showTitle && (
          <div className="p-3 text-align-left title bg-primary">
            {metric.title}
          </div>
        )}
        {!!metric.description && (
          <div className=" p-3 pt-0 text-align-left bg-primary  description">
            {metric.description}
          </div>
        )}
        <div className="p-3 border bg-white">
          {isLoading ? (
            <Loading />
          ) : (
            <VerticalBarChart index={index} data={data} dataKey={dataKey} />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    resident_id: state.filters.resident_id,
    filter_by_resident: state.filters.filter_by_resident,
    resident_statuses: state.filters.resident_statuses,
    group_ids: state.filters.group_ids,
    group_categories: state.filters.group_categories,
    start_date: state.filters.start_date,
    end_date: state.filters.end_date,
    isLoading: true,
    processing: true,
    shouldLoad: true,
  };
}

export default connect(mapStateToProps)(VerticalBarChartLayout);
